import { ScenarioEconomy, ScenarioEconomyCreate, ScenarioEconomyUpdate } from '@/types/scenarioEconomy';
import { apiClient } from './client';

export const scenarioEconomyApi = {
  // Get economy data for a scenario
  getScenarioEconomy: async (scenarioId: string): Promise<ScenarioEconomy> => {
    const response = await apiClient.get<ScenarioEconomy>(`/scenarios/${scenarioId}/economy`);
    return response;
  },

  // Create economy data for a scenario
  createScenarioEconomy: async (scenarioId: string, economyData: ScenarioEconomyCreate): Promise<ScenarioEconomy> => {
    const response = await apiClient.post<ScenarioEconomy>(`/scenarios/${scenarioId}/economy`, economyData);
    return response;
  },

  // Update economy data for a scenario
  updateScenarioEconomy: async (scenarioId: string, economyData: ScenarioEconomyUpdate): Promise<ScenarioEconomy> => {
    const response = await apiClient.put<ScenarioEconomy>(`/scenarios/${scenarioId}/economy`, economyData);
    return response;
  },

  // Delete economy data for a scenario
  deleteScenarioEconomy: async (scenarioId: string): Promise<void> => {
    await apiClient.delete(`/scenarios/${scenarioId}/economy`);
  },
};
